

























































































































import { Mixins, Component, Ref, Watch } from 'vue-property-decorator'
import MixinForm from 'components/presenter/item/topic/editor/MixinForm'
import FormSlide from 'components/presenter/item/topic/editor/FormSlide.vue'
import AnswersEditor from 'components/presenter/item/topic/editor/AnswersEditor.vue'
import IntegerInput from 'components/IntegerInput.vue'
import ModalDialog from 'components/modals/Dialog.vue'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    FormSlide,
    AnswersEditor,
    IntegerInput,
    ModalDialog
  }
})
export default class ItemTopicSlidesEditorFormChoice extends Mixins(MixinForm) {
  correctAnswers = new Set<string>()

  @Ref()
  readonly tailsActionsDialog!: ModalDialog

  get tailsActions (): Json[] {
    return [{
      command: 'sm',
      label: this.$t('slides.edit.choice.tails.sm').toString()
    }, {
      command: 'md',
      label: this.$t('slides.edit.choice.tails.md').toString()
    }, {
      command: 'lg',
      label: this.$t('slides.edit.choice.tails.lg').toString()
    }, {
      command: '',
      label: this.$t('label.off').toString()
    }]
  }

  @Watch('correct', { immediate: true })
  setCorrectAnswers (correct: string[]){
    this.correctAnswers = new Set(correct)
  }

  setTails (value: string) {
    this.tailsActionsDialog.hide()
    this.setOption('tails', value)
  }

  setCorrectAnswer (answer: Json) {
    if (this.correctAnswers.has(answer.id)) {
      this.correctAnswers.delete(answer.id)
    } else {
      this.correctAnswers.add(answer.id)
    }
    this.correctAnswers = new Set(this.correctAnswers)
    const correct = this.correctAnswers.size > 0 ? [...this.correctAnswers] : null
    this.setCorrect(correct)
  }
}
